// Static UI labels for the patient welcome / post-op display, keyed by language.
// The display picks the active map by its own `lang` state (see welcomeLang.js);
// it does NOT use the app's vue-i18n locale. Both locales MUST expose the same
// set of keys — welcomeStrings.spec.js enforces this.
//
// Number/name interpolations (age, duration, "by Dr…", phone) are NOT stored
// here; they are assembled in the component by language so wording order can
// differ between Thai and English.

export const WELCOME_STRINGS = {
  th: {
    // Header
    tagline: "ดูแลรอยยิ้มอย่างอ่อนโยนสำหรับทุกคนในครอบครัว",
    // Welcome board (patient)
    welcomeEyebrow: "ยินดีต้อนรับ",
    greetingHello: "สวัสดีค่ะ",
    sublineGlad: "เราดีใจมากที่ได้พบคุณ",
    tipLabel: "เคล็ดลับรอยยิ้มวันนี้",
    treatmentEyebrow: "การรักษาวันนี้",
    treatmentBy: "โดย",
    alertTitle: "ข้อควรระวังทางการแพทย์",
    allergyKey: "แพ้ยา / สารก่อภูมิแพ้",
    conditionKey: "โรคประจำตัว",
    // General welcome (no patient)
    helloEyebrow: "สวัสดีค่ะ",
    generalFallbackName: "คลินิกของเรา",
    // Post-op care
    postOpEyebrow: "คำแนะนำหลังการรักษา",
    postOpFor: "สำหรับ",
    doTitle: "ควรปฏิบัติ",
    avoidTitle: "ควรหลีกเลี่ยง",
    noteTitle: "ข้อควรรู้",
    contactPrefix: "มีคำถาม? โทร",
    // Doctor control panel
    panelMode: "โหมด",
    panelModeWelcome: "ต้อนรับ",
    panelModePostop: "คำแนะนำหลังรักษา",
    panelTreatment: "ประเภทการรักษา (หลังรักษา)",
    panelTheme: "ธีม (พื้นหลัง / ตัวอักษร)",
    panelLang: "ภาษา",
    panelBg: "พื้นหลัง",
    panelText: "ตัวอักษร",
    gearAria: "ตั้งค่าหน้าจอ",
    navPrev: "ก่อนหน้า",
    navNext: "ถัดไป",
  },
  en: {
    // Header
    tagline: "Gentle smile care for every member of the family",
    // Welcome board (patient)
    welcomeEyebrow: "Welcome",
    greetingHello: "Hello",
    sublineGlad: "We're so glad to see you",
    tipLabel: "Today's smile tip",
    treatmentEyebrow: "Today's treatment",
    treatmentBy: "by",
    alertTitle: "Medical alert",
    allergyKey: "Allergies",
    conditionKey: "Medical conditions",
    // General welcome (no patient)
    helloEyebrow: "Hello",
    generalFallbackName: "Our clinic",
    // Post-op care
    postOpEyebrow: "Post-treatment care",
    postOpFor: "For",
    doTitle: "Do",
    avoidTitle: "Avoid",
    noteTitle: "Good to know",
    contactPrefix: "Questions? Call",
    // Doctor control panel
    panelMode: "Mode",
    panelModeWelcome: "Welcome",
    panelModePostop: "Post-op care",
    panelTreatment: "Treatment type (post-op)",
    panelTheme: "Theme (background / text)",
    panelLang: "Language",
    panelBg: "Background",
    panelText: "Text",
    gearAria: "Display settings",
    navPrev: "Previous",
    navNext: "Next",
  },
};
